export default {
    message: {
        'header': {
            'online': 'online'
        },
        'footer': {
            'home': 'Página inical',
            'points': 'Pontos',
            'vip_zone': 'Zona VIP',
            'order': 'Pedido',
            'account': 'Conta'
        },
        'index': {
            'notice1': "Parabéns ao jogador",
            'notice2': "'participação, ganhou",
            'notice3': "Vamos dar-lhe os parabéns",
            'hot_spot': 'PONTO QUENTE',
            'all_goods': 'Todos os bens',
            'promotion_type': 'Tipo de promoção',
            'partners': 'Parceiros',
            'announcement': 'O anúncio',
            'cancel': 'Cancelar',
            'travel_to': 'Para viajar a',
            'ok': 'OK'
        },
        'goods': {
            'name1': 'Duplo reembolso',
            'name2': 'Dinheiro x 2 reembolso',
            'name3': 'Reembolso de 70 vezes (VIP1)',
            'name4': 'Dinheiro x 72 reembolso'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Favor selecionar',
            'product_description': 'Descrição de produto',
            'check_out': 'Verificar',
            'original_price': 'Preço original',
            'inventory': 'Inventário',
            'sold': 'Vendido',
            'tip_start': 'O sucesso da promoção pode ser melhorado para bens avaliados em ',
            'tip_end': ' moeda gratuita',
            'quantity': 'Quantidade',
            'total_price': 'Preço total',
            'win_rate': 'Taxa de ganho',
            'predict_type': 'Tipo de prognóstico',
            'member_shared': 'Membro partilhado receberá',
            'share_now': 'Partilhar agora',
            'copy_the_link': 'Copiar o link',
            'send_to_friend': 'Enviar para amigo',
            'copy_success': 'Copiado com sucesso',
            'copy_error': 'Erro de cópia'
        },
        'integral': {
            'title': 'Zona de troca de pontos',
            'search': 'Pesquisa de informação sobre produtos',
            'points': 'Pontos'
        },
        'vip_zone': {
            'title': 'Lista de bens de VIP',
            'price': 'Preço',
            'sales_volume': 'Volume de vendas'
        },
        'login': {
            'account_login': ['Login com conta'],
            'login': 'Login',
            'phone': 'Inserir o seu número de telelfone',
            'pwd': 'Inserir a sua senha',
            'no_account': 'Tem uma conta?',
            'forgot_password': 'Esqueci da senha',
            'register': 'Registar-se'
        },
        'reset_pwd': {
            'title': 'Recuperar a senha',
            'get_verification_code': 'Obter o código de verificação',
            'confirm': 'Confirmar',
            'verification_code': 'Código de verificação',
            'your_new_pwd': 'Sua nova senha',
            'reload': 'Recarregar',
            'msg_phone': 'Insira o seu número de telefone'
        },
        'register': {
            'register_account': 'Registar a Conta',
            'account': 'Número de telefone',
            'pwd': 'Senha de login',
            'con_pwd': 'Confirmar a senha',
            'register': 'registar-se',
            'tip_account': 'Tem uma conta?',
            'by_click': 'Ao clicar em "registar-se", significa que concorda com o centro comercial',
            'privacy_policy': 'Política de Privacidade',
            'tip_wrong': '*O número de telemóvel errado não pode utilizar o website normalmente.',
            'msg_phone': 'Erro do formato de telefone'
        },
        'order': {
            'submit_order': 'Submeter o pedido',
            'item': 'Item',
            'payment_method': 'Método de pagamento',
            'pay_via_balance': 'Pagar por saldo',
            'balance_available': 'Saldo disponível',
            'total_price': 'Preço total',
            'total': 'Total',
            'check_out': 'Verificar',
            'msg_param': 'O parâmetro está errado',
            'msg_order_field': 'Falha ao carregar os dados do pedido',
            'msg_select_payment': 'Selecione o método de pagamento',
            'tip_create_order': 'Criando o pedido...',
            'payment_succeeded': 'Pagamento com sucesso',
            'payment_fail': 'Falha ao pagar',
            'order_no': 'Pedido No.',
            'order_time': 'Hora do pedido',
            'other': 'Outro',
            'total_amount': 'Montante Total',
            'failure_reason': 'razão de falha',
            'view_payment_results': 'Ver os resultados de pagamento',
            'payment_failed_to_repay': 'Falha ao pagar e tente novemente',
            'top_up': 'recarga',
            'hot_spot': 'PONTO QUENTE',
            'back_home': 'Voltar à página inicial',
            'msg_create_success': 'Pedido criado com sucesso',
            'confirm_title': 'pagar',
            'confirm_msg': 'Falha ao pagar,',
            'confirm_cancel': 'Cancelar',
            'confirm_top_up': 'recarga',
            'game_odd': 'ímpar',
            'game_even': 'Par',
            'game_title': 'ÍMPAR OU PAR',
            'game_select_title': 'Selecione o seu resultado antecipado',
            'game_odd_number': 'Número ímpar',
            'game_even_number': 'Número par',
            'game_confirm_selection': 'Confirmar a seleção',
            'game_opening_time': 'Hora de abertura',
            'game_issue': 'Assunto',
            'game_number': 'Número',
            'game_results': 'Resultados',
            'game_submit_err': 'erro: a ID do pedido não existe!',
            'game_choose_least': 'Selecione pelo menos um!',
            'game_success': 'sucesso',
            'game_error': 'erro',
            'game_confirm': 'Confirmar',
            'game_confirm_title': 'messagem',
            'game_confirm_msg': 'Tem certeza de selecionar este?',
            'game_confirm_cancel': 'cancelar',
            'chart': 'Gráfico',
            'close': 'Fechar',
            'bulls_eye': 'OLHO DE TOUROS',
            'trend_recent': 'Tendência dos últimos 50 períodos',
            'number': 'Número',
            'times_without': 'vezes sem',
            'bet': 'aposta'
        },
        'my_order': {
            'title': 'Meu pedido',
            'operated': 'operado',
            'receive': 'Receber',
            'completed': 'Completado',
            'converted': 'Convertido',
            'refund': 'Reembolsar',
            'item_total_amount': 'Item，Montante total',
            'picking_up': 'Levantnado',
            'redeem_points': 'Pontos resgatados',
            'processing_pick_up': 'Processamento para levantar',
            'hot_spot': 'PONTO QUENTE',
            'view_details': 'Ver detalhes',
            'check_tracking': 'Verificar informação de rastreio',
            'confirm_receival': 'Confirmar o  recebimento',
            'receipt': 'Recebimento',
            'cancel': 'Cancelar',
            'confirm_pick_up': 'Confirmar o levantamento',
            'not_sales': 'Ainda não está em venda',
            'sales_failed': 'Vendas falharam',
            'sales_success': 'Vendas com sucesso',
            'waiting_draw': 'À espera de sorteio',
            'bonus_countdown': 'Contagem decrescente de bónus',
            'redeem_success': 'Resgatar o sucesso',
            'awarded': 'Atribuído',
            'points': 'pontos',
            'fee': 'Taxa',
            'cash': 'dinheiro',
            'sure': 'certo',
            'detail_title': 'Detalhes do pedido',
            'detail_copy': 'Copiar',
            'detail_order_no': 'Pedido No.',
            'detail_order_time': 'Hora do pedido',
            'detail_type_order': 'Tipo do pedido',
            'detail_status_payment': 'Estado de pagamento',
            'detail_have_pay': 'Tem de pagar',
            'detail_did_pay': 'Não pagou',
            'detail_promotion_status': 'Estado de promoção',
            'detail_promotion_period': 'Perído de promoção',
            'detail_promotion_games': 'Jogos de promoção',
            'detail_opening_time': 'Hora de operação',
            'detail_my_choice': 'Minha escolha',
            'detail_lottery_numbers': 'Números da lotaria',
            'detail_payment_method': 'Método de pagamento',
            'detail_total_amount': 'Montante Total',
            'detail_amount_paid': 'Montante pago',
            'detail_re_order': 'Pedido de novo'
        },
        'user': {
            'account': 'Conta',
            'available_balance': 'Saldo disponível',
            'my_points': 'Meus pontos',
            'active_code': 'Código ativo',
            'your_code': 'Insira o seu código',
            'msg_code': 'Preencha o código de troca',
            'ok': 'OK',
            'deposit': 'Depositar',
            'withdraw': 'Retirar',
            'confirm_title': 'Confirmar a alteração?',
            'confirm_msg': 'Alteração do avatar do utilizaor',
            'confirm_cancel': 'Cancelar',
            'confirm_ok': 'Confirmar',
            'cancelled': 'Cancelado',
            'profile_title': 'Perfil do utilizador',
            'profile_manage_account': 'Gerir a minha conta',
            'profile_nickname': 'apelido',
            'profile_real_name': 'Nome real',
            'profile_email': 'E-mail',
            'profile_phone': 'Telefone',
            'profile_password': 'Senha',
            'profile_click_change_password': 'Clicar em alterar a senha',
            'profile_save_the_change': 'Salvar a alteração',
            'profile_log_out': 'Logout',
            'profile_confirm_title': 'Logout',
            'profile_confirm_msg': 'Confirmar logout?',
            'profile_confirm_cancel': 'Cancelar',
            'profile_confirm': 'Confirmar',
            'change_password_title': 'Alterar a Senha',
            'change_password_current_pwd': 'Inserir a sua senha atual',
            'change_password_set_new_pwd': 'Definir a nova senha',
            'change_password_confirm_new_pwd': 'Confirmar a nova senha',
            'change_password_confirm_change': 'Confirmar a alteração',
            'change_password_msg_current_pwd': 'Insira a senha atual',
            'change_password_msg_new_pwd': 'Insira a nova senha',
            'change_password_msg_new_pwd_again': 'Insira a nova senha de novo',
            'change_password_msg_not_match': 'As senhas são diferentes',
            'user_rank_title': 'Registo de abertura de prémio',
            'user_menu_bulletin': 'Boletim',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'Pagamento com Binance',
            'user_menu_agent': 'Agente',
            'user_menu_balance_details': 'Detalhes de saldo',
            'user_menu_lottery_record': 'Registo da lotaria',
            'user_menu_service': 'Serviço',
            'user_menu_about_us': 'Sobre nós'
        },
        'balance_detail': {
            'title': 'Detalhes do saldo',
            'total_amount': 'Montante total',
            'top_up': 'Recarga',
            'accumulated_withdrawal': 'Retiradas acumuladas',
            'bill_record': 'Registo de conta',
            'consumption_records': 'Registos de consumo',
            'recharge_records': 'Registos de recarga',
            'points_center': 'Centro de pontos',
            'sign_in': 'Iniciar a sessão para recolher pontos',
            'upgrade_level': 'Atualizar níveis para desbloquear mais jogo！'
        },
        'my_pay': {
            'title': 'Vincular a carteira eletrónica',
            'phone': 'Telefone',
            'phone_plac': 'Inserir o seu telefone',
            'binance_id': 'Binance ID',
            'binance_id_plac': 'Inserir a Binance ID',
            'pay_nickname': 'Apelido de pagamento',
            'pay_id': 'ID dePagamento',
            'pay_id_plac': 'Inserir a ID de Pagamento',
            'tip': 'Certifique-se de que toda a informação está correta, caso contrário não poderá retirar.',
            'bind': 'Vincular',
            'edit': 'Editar',
            'msg_nickname': 'Insira o apelido de pagamento',
            'confirm_msg': "<b style='color: red'>Nota</b>: O apelido de pagamento só pode ser alterado uma vez ! ! !<br>Apelido de pagamento:",
            'confirm_title': 'Editar o apelido de Pagamento Binance',
            'confirm_cancel': 'Cancelar',
            'confirm_cancelled': 'Cancelado',
            'confirm_confirm': 'Confirmar',
            'msg_phone': 'Inserir o número de telefone',
            'msg_binance_id': 'Inserir a Binance ID',
            'msg_binance_id_format': 'Erro do formato da Binance ID',
            'msg_pay_nickname': 'Insira o apelido de pagamento',
            'msg_pay_id': 'Insira a ID de pagamento',
            'msg_pay_id_format': 'Erro do formanto da ID de pagamento',
            'msg_pay_id_length': 'Erro do comprimento da ID de pagamento',
            'msg_binance_pay': 'A Binance ID não é a ID de pagamento, a ID de pagamento pode ser encontrada na página de recebimento.',
            'msg_confirm_title': 'Informação de Confirmação de Pagamento Binance',
            'msg_confirm_msg1': 'Seu apelido de pagamento',
            'msg_confirm_msg2': 'Sua ID de pagamento',
            'msg_confirm_msg3': 'Nota: Uma vez confirmado, não pode ser desvinculado!',
            'msg_confirm_cancel': 'Cancelar',
            'msg_confirm_cancelled': 'Cancelado',
            'msg_confirm': 'Confirmar',
            'bind_success_msg': 'Vinculado com sucesso，Você obtem'
        },
        'user_bill': {
            'title': 'Detalhes do saldo',
            'all': 'Tudo',
            'consumption': 'Consumo',
            'recharge': 'Recarga',
            'income': 'Receita'
        },
        'user_integral': {
            'title': 'Detalhes de pontos',
            'current_points': 'Pontos atuais',
            'accumulated_points': 'Pontos acumulados',
            'accumulated_consumption': 'Consumo acumulado',
            'obtained_today': 'Obtidos hoje',
            'details_points': 'Detalhes de pontos',
            'increase_points': 'Aumentar pontos',
            'points_rewarded_purchasing': 'Pontos recompensados pela compra do artigo',
            'earn_points': 'Ganhar pontos',
            'points_rewarded_sign': 'Pontos recompensados por assinatura diária',
            'sign_points': 'Ponots',
            'sign_details': 'Detalhes',
            'sign_signed': 'Assinado',
            'sign_sign': 'Assinar',
            'sign_accumulated_sign': 'Assinaturas acumuladas',
            'sign_days': 'dias',
            'sign_tip2_s': 'Diz-se que',
            'sign_tip2_e': '  dias de assinatura contínua terá pontos enormes recompensados, não se esqueça de assinar~~~',
            'sign_click_load_more': 'Clicar para carregar mais',
            'sign_success': 'Assinado com sucesso',
            'sign_awarded': 'Atribuído',
            'sign_sure': 'certo',
            'sign_cnum': ["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"],
            'sign_msg_signed': 'Assinou hoje!',
            'detail_title': 'Pedido para pontos',
            'detail_phone': 'Telefone',
            'detail_payment_method': 'Método de pagamento',
            'detail_pay_with_points': 'Pagar com pontos',
            'detail_available_points': 'Pontos disponíveis',
            'detail_total': 'Total',
            'detail_points': 'Pointos',
            'detail_check_out': 'Verificar',
            'pay_points': 'Pagar os pontos',
            'detail_parameter_wrong': 'O parâmetro está errado',
            'detail_failed_data': 'Falha ao carregar dados do pedido',
            'detail_creating_order': 'Criando pedido...',
            'detail_creating_order_fail': 'Criação do pedido falhou',
            'detail_status_title': 'Troca de bens com sucesso',
            'detail_status_check_mailbox': 'Verifique a sua caixa de correio, entregaremos o produto dentro de 24 horas.',
            'detail_status_view_order': 'Para ver o pedido',
            'detail_status_back_home': 'Voltar à página inicial',
            'detail_points_title': 'Detalhes de pontos',
            'my_order_points_title': 'Meu pontos de pedido'
        },
        'recharge': {
            'title': 'Submeter pedido de recarga',
            'first_deposit': 'Bóbus do primeiro depósito',
            'use_binance': 'Usar Binance',
            'choose_amount': 'Escolha o montante e continue',
            'current_balance': 'Nota: Saldo atual',
            'confirm_top_up': 'Confirmar a recarga',
            'application_details': 'Detalhes do pedido de recarga',
            'order_number': 'Número do pedido',
            'application_time': 'Hora do pedido',
            'top_up_amount': 'Montante de recarga',
            'top_up_status': 'Estado de recarga',
            'reviewing': 'Revendo',
            'application_success': 'Pedido com sucesso',
            'application_failed': 'Pedido falhou',
            'msg_bind_binance': 'Vincule o Pagamento Binance',
            'msg_minimum_bank': 'Mínimo 100 para recarga',
            'msg_minimum_binance': 'Mínimo 1 para recarga',
            'msg_enter_top_up_amount': 'Insira o montante de recarga',
            'confirm_title': 'Confirmar os detalhes do depósito',
            'confirm_verify_information': 'Verifique as informações',
            'confirm_tip': 'Envie dinheiro para qualquer uma das seguintes contas usando o Pagamento Binance vinculado, clique no canto superior direito para ver o tutorial.',
            'confirm_our_pay_id': 'Nossa ID de pagamento',
            'confirm_copy': 'Copiar',
            'confirm_top_up_amount': 'Montante de recarga',
            'confirm_confirm_top_up': 'Confirmar a recarga',
            'confirm_msg_copy': 'Copiado com sucesso',
            'confirm_msg_enter_amount': 'Insira o montante de recarga',
            'confirm_transfer_amount': 'Montante mínimo de transferência de 1',
            'confirm_alert_mes': 'Confirme que o Pagamento Binance vinculado foi utilizado para o pagamento.<b style=\'color: red\'> Espere 5-10 minutos para a chegada. </b>Se tiver qualquer dúvida, entre em contato com o serviço de atendimento ao cliente a tempo.',
            'confirm_alert_title': 'Submeter o pedido de recarga',
            'confirm_alert_cancel': 'Cancelar',
            'confirm_alert_msg_cancelled': 'Cancelado',
            'confirm_alert_confirm': 'Confirmar'
        },
        'withdrawal': {
            'title': 'Retirar',
            'link_now_tip': 'Ainda não vinculou a carteira eletrónica, vincule e submeta novamente o pedido de retirada',
            'link_now': 'Vincule agora',
            'withdrawal_account': 'Conta de retirada',
            'phone': 'Telefone',
            'binance_id': 'ID de Binance ',
            'nickname': 'Apelido',
            'pay_id': 'ID de pagamento',
            'withdraw_amount': 'Montante de retirada',
            'balance': 'saldo',
            'processing_fee': 'Taxa de processamento',
            'actual_amount': 'montante atual',
            'msg_withdrawal_account': 'Selecione o montante de retirada',
            'msg_fill_data': 'Preenche nos dados',
            'msg_phone': 'Insira o número de telefone',
            'msg_binance_id': 'Insira a ID de Binance',
            'msg_binance_pay_id': 'Insira a ID de Pagamento Binance',
            'msg_pay_id_err': 'Erro do formanto da ID de pagamento',
            'msg_withdraw_amount': 'Insira o montante de retirada',
            'msg_insufficient_balance': 'Saldo insuficiente',
            'msg_mini_withdraw': 'Mínimo 160 para retirada',
            'msg_minimum': 'Mínimo',
            'msg_to_withdraw': 'para retirada',
            'audit_tip': 'Retirda foi submetida, espera para a revisão',
            'audit_sure': 'certo'
        },
        'user_vip': {
            'title': 'Centro de membro',
            'able_purchase': 'Capaz de comprar artigo em',
            'off': 'ligado',
            'level_task1': 'Completar o Depósito de 1USDT e comprar bens 50 vezes para se tornar um VIP!',
            'level_task2': 'Taxa de retirada',
            'level_task3': 'Hora de retirada',
            'level_task4': 'H',
            'vip_level_unlocked': 'Nível VIP bloqueado',
            'higher_level_unlocked': 'Nível mais alto desbloqueado',
            'vip_upgrade_requirements': 'Requisitos de atualização VIP',
            'required_tasks': 'Tarefas exigidas',
            'select_one_below': 'Selecione um dos seguintes',
            'achieved': 'atingido',
            'conditions_met': 'não atendeu às condições',
            'accumulated_participation': 'participações acumuladas no jogo',
            'achieved_top_up': 'Acumulou 50 moedas para recarga',
            'exclusive_coupons': 'coupons exclusivos',
            'more_games': 'mais jogos',
            'need_recharge': 'Deve recarregar 50 moedas'
        },
        'promoter': {
            'title': 'Gestão de promotores',
            'apply_agency': 'Candidate-se ao agente e torne-se um de nós',
            'become_agent': 'Tornar-se um agente',
            'repeatedly_delayed': 'O carregamento pode ser atrasado,  aguarde um pouco e não clique repetidamente！',
            'current_commission': 'Comissão atual',
            'record': 'registo',
            'profit_yesterday': 'Lucro de ontem',
            'accumulated_withdrawal': 'Retirada acumulada',
            'withdraw': 'retirada',
            'refer_friends': 'Indicar amigos',
            'total_agent': 'Agente total',
            'copy_success': 'Copiado com sucesso',
            'copy_error': 'Erro de cópia',
            'promoter_achievements': 'Realizações de promotor',
            'promoter_orders': 'Pedido de promotor',
            'promoter_ranking': 'Classificação de promotor',
            'commission_ranking': 'Classificação de comissão',
            'list_title': 'Número de agentes',
            'list_number_agents': 'Número de agentes',
            'list_people': 'pessoas',
            'list_date_joined': 'Data de adesão',
            'list_item': 'item',
            'order_title': 'Pedidos acumulados',
            'order_accumulated_orders': 'Pedidos acumulados',
            'order_commission': 'comissão',
            'order_time': 'Hora de pedido',
            'order_mark': 'marca',
            'commission_title': 'Realizações de promotor',
            'commission_accumulated_commission': 'Comissão acumulada',
            'commission_available': 'Comissão disponível para retirada',
            'commission_week': 'Novos membros desta semana',
            'commission_month': 'Novos membros deste mês',
            'commission_achievement': 'Realização',
            'commission_rank_title': 'Classificação de comissão',
            'commission_rank_current': 'Sua classificação atual',
            'commission_rank_yet': 'Você não está na classificação ainda',
            'rank_title': 'Classificação de promotor',
            'cash_record_title': 'Detalhes de retirada de comissão',
            'cash_record_cash_out': 'Registo de levantamentos',
            'user_cash_title': 'Commission withdrawal',
            'user_cash_not_link': 'Ainda não vinculou a carteira eletrónica, vincule e submeta novamente o pedido de retirada',
            'user_cash_link_now': 'Vincular agora',
            'user_cash_service_provider': 'Prestador de serviço',
            'user_cash_select_account': 'Selecione o montante de retirada',
            'user_cash_binance_pay': 'Pagamento Binance',
            'user_cash_bank_account': 'Conta Bancária',
            'user_cash_bank_account_pla': ' Preencha o número da sua conta bancária',
            'user_cash_ifsc_pla': 'Preencha a sua conta IFSC',
            'user_cash_upi_pla': 'Preencha o número da sua conta UPI',
            'user_cash_withdraw': 'Retirada',
            'user_cash_minimum': 'Mínimo',
            'user_cash_to_withdraw': 'para retirar',
            'user_cash_current_commission': 'Comissão atual disponível para retirada!',
            'user_cash_account': 'Conta',
            'user_cash_account_pla': 'Preencha o seu nome de utlizador de alipay',
            'user_cash_current_withdrawal': 'Comissão de retirada atual',
            'user_cash_to_e_wallet': 'Retirar para a carteira eletrónica',
            'user_cash_to_balance': 'Retirar para saldo',
            'user_cash_insufficient_balance': 'Saldo insuficiente',
            'user_cash_data_format': 'Dados em formato errado'
        },
        'service': {
            'title': 'Registo de mensagens',
            'write_email': 'Escreve-nos um email'
        }
    }
};